export default {"src":"/_next/static/media/Logomark.0e1141a0.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};